
export default {
  computed: {
    url () {
      return this.$store.state.site
    }
  }
}
